import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Login from '../pages/login'
import Signup from '../pages/signup'
// import Header from '../components/header/header'
import Parentlayout from './parentlayout'
import Protectroutes from './protectroutes'
import Producthome from '../pages/producthome'
import Adminhome from '../pages/adminhome'
import Dashboard from '../pages/Dashboard/dashboard'
import Dashboarlayout from '../pages/Dashboard/dashboarlayout'
import Agents from '../pages/Agents '
import Campaign from '../pages/Campaign/Campaign'
import Config from '../pages/Config'
import Automation from '../pages/Automation'
import Report from '../pages/Report'
import Loader from '../pages/Loader/loader'
import Approval from '../pages/approval/approval'
import UserManagement from '../pages/adminpages/UserManagement'
import ClientList from '../pages/adminpages/ClientList'
import ClinttreeList from '../pages/adminpages/clinttreeList'
import SiteBranding from '../pages/adminpages/SiteBranding'
import SystemCreditHistory from '../pages/adminpages/SystemCreditHistory'
import DomainSmartLink from '../pages/adminpages/DomainSmartLink'
import ArchiveReportCommon from '../pages/adminpages/ArchiveReportCommon'
import SystemTraffic from '../pages/adminpages/SystemTraffic/SystemTraffic'
import DateWiseStatistics from '../pages/adminpages/DateWiseStatistics/DateWiseStatistics'
import DeliveryBaseUserReports from '../pages/adminpages/DeliveryBaseUserReports/DeliveryBaseUserReports'
import PRINumbers from '../pages/adminpages/PRINumbers'
import ComingSoon from '../pages/Comingsoon'
import DLTBulkUploader from '../pages/adminpages/DLTBulkUploader'
import WABAChannels from '../pages/Config/WABAChannels'
import WhatsAppTemplates from '../pages/Config/WhatsAppTemplates'
import SetupTemplate from '../pages/Config/SetupTemplate'
import UnsubscribedNumbers from '../pages/Config/UnsubscribedNumbers'
import GroupList from '../pages/Config/GroupList'
import Edittemplate from '../pages/Config/Edittemplate'
import SetupYourTemplate from '../pages/Config/setupYourTemplate'
import Templatelibrary from '../pages/Config/templatelibrary'
import Profile from '../pages/Profile/profile'
import Password from '../pages/Profile/password'
import Test from '../Test/Test'
import Error from '../components/ApiValidation/Error'
import Success from '../components/ApiValidation/Success'
import MediaLibrary from '../pages/Config/MediaLibrary'
import BlackListNumbers from '../pages/Config/BlackListNumbers'
import Chatbot from '../pages/Automations/chatbot'
import Chatbotflowbuilder from '../pages/Automations/chatbotflowbuilder'
import Whatsappflow from '../pages/Automations/whatsappflow'
import UserChatBox from '../pages/agents/UserChatBox'
import ReportsDownload from '../pages/agents/ReportsDownload'
import UserChatArchive from '../pages/agents/UserChatArchive'
import AgentList from '../pages/agents/AgentList'
import WhatsAppContacts from '../pages/agents/WhatsAppContacts'
import JourneyCampaigns from '../pages/Report/JourneyCampaigns'
import FlowReport from '../pages/Report/FlowReport'
import DeliveryStatistics from '../pages/Report/DeliveryStatistics'
import CampaignActivity from '../pages/Report/CampaignActivity'
import DailyConsumption from '../pages/DailyConsumption'
import Qrcode from '../pages/Automations/Qrcode'
import EmailProvider from '../pages/Automations/EmailProvider'
import WhatsAppWidget from '../pages/Automations/WhatsAppWidget'
import AddEditFlow from '../pages/Automations/AddEditFlow'
import ManageContacts from '../pages/Config/ManageContacts'
import BusinessProfile from '../pages/adminpages/users/BusinessProfile'
import ApiPostman from '../pages/APISTRUCTURE/Api_postman';
import SSOLogin from '../components/Redirect/sso-login';

function Layouts() {
    return (
        <>
            <Routes >
                {/* <Route path="/" element={
                    <Protectroutes>
                        <Dashboarlayout />
                    </Protectroutes>}>
                    <Route path="ProductsHome" element={<h1>Products home</h1>} />
                    <Route path="AdminHome" element={<Adminhome />} />
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/agents" element={<Agents />} />
                        <Route path="/WAMessage/WASendMessage/Index" element={<Campaign />} />
                        <Route path="/configuration" element={<Config />} />
                        <Route path="/Automation" element={<Automation />} />
                        <Route path="/Report" element={<Report />} />
                </Route> */}
                 
                {/* Protectroutes checks if user is logged in, and only renders the child if authenticated */}
                <Route path="/sso-login" element={<SSOLogin />} />
                <Route
                    path="/"
                    element={
                        <Protectroutes>
                            <Parentlayout />
                        </Protectroutes>
                    }
                >
                    <Route path="Comingsoon" element={<ComingSoon />} />
                    <Route path="error" element={<Error />} />
                    <Route path="success" element={<Success />} />
                    <Route path="ProductsHome" element={<Producthome />} />
                    <Route path="DailyConsumption" element={<DailyConsumption />} />
                    <Route path="AdminHome" element={<Adminhome />} />
                    <Route path="AdminHome" element={<Adminhome />} />
                    <Route path="Approval" element={<Approval />} />
                    <Route path="Admin/UserManagement/Index" element={<UserManagement />} />
                    <Route path="Admin/ClientLists/Index" element={<ClientList />} />
                    <Route path="Admin/ClientTreeList/Index" element={<ClinttreeList />} />
                    <Route path="Admin/SiteBranding/Index" element={<SiteBranding />} />
                    <Route path="Admin/SystemCreditHistory/Index" element={<SystemCreditHistory />} />
                    <Route path="Admin/DomainSmartLink/Index" element={<DomainSmartLink />} />
                    <Route path="Admin/ArchiveReportCommon/Index" element={<ArchiveReportCommon />} />
                    <Route path="Admin/SystemTraffic/Index" element={<SystemTraffic />} />
                    <Route path="Admin/DateWiseStatistics/Index" element={<DateWiseStatistics />} />
                    <Route path="Admin/DeliveryBaseUserReports/Index" element={<DeliveryBaseUserReports />} />
                    <Route path="Admin/DLTBulkUploader/Index" element={<DLTBulkUploader />} />
                   
                    
                    <Route path="Exchange/PRINumbers/Index" element={<PRINumbers />} />
                    <Route path="/Client/MyProfile" element={<Profile />} />
                    <Route path="/Client/MyPassword" element={<Password />} />
                    <Route path="/WAMessage/UserChatBox" element={<UserChatBox />} />
                    <Route path="/Admin/DownloadReport" element={<ReportsDownload />} />
                    <Route path="/WAMessage/UserChatArchive" element={<UserChatArchive />} />
                    <Route path="/Journeys/JourneyCampaignActivity" element={<JourneyCampaigns />} />
                    <Route
                      path="/"
                      element={
                        <Protectroutes>
                          <Dashboarlayout />
                        </Protectroutes>
                      }
                    >
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/agents" element={<Agents />} />
                        <Route path="/agents" element={<Agents />} />
                        <Route path="/" element={<Campaign />} />
                        <Route path="/WAMessage/WASendMessage/Index" element={<Campaign />} />
                        <Route path="/configuration" element={<Config />} />
                        <Route path="/Automation" element={<Automation />} />
                        <Route path="/Report" element={<Report />} />
                        <Route path="/WAMessage/WABAChannels/Index" element={<WABAChannels />} />
                        <Route path="WAMessage/WABusinessProfile/BusinessProfile" element={<BusinessProfile />} />
                        <Route path="/WAMessage/WATemplate/Index" element={<WhatsAppTemplates />} />
                        <Route path="WAMessage/WATemplate/AddEditTemplate" element={<Edittemplate />} />
                        <Route path="WAMessage/WATemplate/AddEditTemplate/:id" element={<Edittemplate />} />
                        <Route path="/WAMessage/WATemplate/SetupTemplate" element={<SetupYourTemplate />} />
                        <Route path="/WAMessage/Templatelibrary/Index" element={<Templatelibrary />} />
                        {/* <Route path="/WAMessage/WATemplate/SetupTemplate" element={<SetupTemplate />} /> */}
                        <Route path="/WAMessage/UnsubscribedNumbers/Index" element={<UnsubscribedNumbers />} />
                        <Route path="/Client/Groups/Index" element={<GroupList />} />
                        <Route path="/groups/:groupId/contacts" element={<ManageContacts />} />
                        <Route path="/WAMessage/WAMediaLibrary/Index" element={<MediaLibrary />} />
                        <Route path="/Client/BlackListNumbers/Index" element={<BlackListNumbers />} />
                        <Route path="/WAMessage/WAFlow/AddEditFlow" element={<AddEditFlow />} />
                        <Route path="/WAMessage/WAChatbotFlow/Index" element={<Chatbot />} />
                        <Route path="/WAMessage/WAChatbotFlow/Index/:id" element={<Chatbotflowbuilder />} />
                        <Route path="/WAMessage/WAFlow/Index" element={<Whatsappflow />} />
                        <Route path="/WAMessage/AgentList" element={<AgentList />} />
                        <Route path="/WAMessage/WAContact" element={<WhatsAppContacts />} />
                        <Route path="/WAMessage/WAQRCodes" element={<Qrcode />} />
                        <Route path="/Client/EmailProvider" element={<EmailProvider />} />
                        <Route path="/WAMessage/WAWidgets" element={<WhatsAppWidget />} />
                        <Route path="/WAMessage/WAFlowHistory" element={<FlowReport />} />
                        <Route path="/WAMessage/DeliveryStatistics" element={<DeliveryStatistics />} />
                        <Route path="/WAMessage/WACampaignActivity" element={<CampaignActivity />} />
                        <Route path="/developer/console" element={<ApiPostman />} />
                    </Route>
                </Route>
                 
                <Route path='/login' element={<Login />} />
                <Route path='/signup' element={<Signup />} />
                <Route path='/waconf' element={<Test />} />
            </Routes>
        </>
    )
}

export default Layouts
